import { type FC } from "react";
import { Dialog } from "@mui/material";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useCreateContentMutation } from "@/partner/entities/contents";
import { ContentTypeType } from "@/types/graphql/partner.generated";
import type { CollectionFormValues } from "../model";
import { CollectionForm } from "./CollectionForm";

interface CreateCollectionDialogProps {
  open: boolean;
  onClose: () => void;
  onCompleted?: () => void;
}

// Порт референсного CreateCollectionDialog: полноэкранная форма поверх
// списка, создание через общий createContent {type: COLLECTION}.
export const CreateCollectionDialog: FC<CreateCollectionDialogProps> = ({
  open,
  onClose,
  onCompleted,
}) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [createContent, { loading }] = useCreateContentMutation({
    onCompleted: () => {
      enqueueSnackbar(t("collections.create.success"), { variant: "success" });
      onCompleted?.();
    },
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: "error" });
    },
    refetchQueries: ["CollectionsList", "CollectionOptions"],
  });

  const handleSubmit = async (values: CollectionFormValues) => {
    await createContent({
      variables: { input: { ...values, type: ContentTypeType.CollectionType } },
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <CollectionForm
        title={t("collections.create.title")}
        loading={loading}
        onSubmit={handleSubmit}
        onClose={onClose}
      />
    </Dialog>
  );
};
